import React from 'react';
import { useSEO } from '@/hooks/useSEO';
import { PageHero } from '@/pages/About';
import { useLanguage } from '@/contexts/LanguageContext';

const HERO = 'https://images.unsplash.com/photo-1515263487990-61b07816b324?w=2000&q=80&auto=format&fit=crop';

const AssetManagement = () => {
  const { t } = useLanguage();
  useSEO({ title: 'Turto valdymas — UAB MAIŠIAGALA GROUP', description: 'Profesionalus turto valdymas: investicijų valdymas, sandorių priežiūra, finansinė kontrolė.', path: '/asset-management' });
  const services = t('asset.services') || [];

  return (
    <div data-testid="asset-page">
      <PageHero title={t('asset.title')} image={HERO} />

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <p className="text-white/60 max-w-2xl text-lg mb-16">{t('asset.lead')}</p>

        <div className="border-t border-[#262626]">
          {services.map((s, i) => (
            <div
              key={i}
              className="grid grid-cols-1 md:grid-cols-12 gap-8 py-12 border-b border-[#262626] group hover:bg-[#141414]/40 transition-colors duration-500"
              data-testid={`asset-service-${i}`}
            >
              <div className="md:col-span-1 text-gold font-serif text-3xl">0{i + 1}</div>
              <div className="md:col-span-5">
                <h3 className="font-serif text-white text-2xl sm:text-3xl tracking-tight group-hover:text-gold transition-colors">
                  {s.t}
                </h3>
              </div>
              <p className="md:col-span-6 text-white/70 text-lg leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default AssetManagement;
